import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentApprovedMedium(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        width={63.5}
        height={78.5}
        x={18.25}
        y={10.87}
        stroke="url(#document_approved_medium_svg__a)"
        strokeWidth={8.35}
        rx={11.15}
      />
      <path stroke="#0D2B57" strokeWidth={0.84} d="M32.47 28.84h35.09m-35.09 8.35h35.09" />
      <rect width={32.59} height={32.59} x={59.32} y={56.54} fill="#0D2B57" rx={16.29} />
      <rect
        width={32.59}
        height={32.59}
        x={59.32}
        y={56.54}
        stroke="#fff"
        strokeWidth={0.84}
        rx={16.29}
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.84}
        d="m69.26 73.65 2.93 3.13 6.82-8.35"
      />
      <defs>
        <linearGradient
          id="document_approved_medium_svg__a"
          x1={50}
          x2={50}
          y1={10.87}
          y2={89.41}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentApprovedMedium);
export default ForwardRef;
